import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import CreateBloc from './Blocs/CreateBloc'
import { accessRole } from "../../../../helpers/access_role"

var reformatEmployee = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.employee_nip+" - "+region.employee_name;
      newObj["value"] = region.employee_uuid;
      newObj["model"] = region;
      return newObj;
    });
};


var reformatHukuman = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.punishment_link_name;
      newObj["value"] = region.punishment_uuid;
      return newObj;
    });
};

class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {
                nip: "",
                nama: "",
                unit_kerja: "",
                jabatan: "",
                tmt_jabatan: "",
                tgl_pensiun:"",
                golongan: "",
                punishment_sk_number: "",
                punishment_sk_date: "",
                punishment_sk_tmt_date: ""
            },
            employeeItems: [],
            employeeSelected: "",
            hukumanItems: [],
            hukumanSelected: "",
        }
    }

    submitData = async () => {
        if(this.state.dataForm.document.length > 0){
            let formData = generateFormData(this.state.dataForm, 'document')
            //console.log(this.state.dataForm)
            await this.createBloc.fetchCreate(formData)
        }else{
            await this.createBloc.fetchCreate(this.state.dataForm)
        }     
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    onChangeEmployee = (employee) => {
        var model = employee.model
        this.setState({
            employeeSelected: employee.value,
            dataForm: {
                nip: model.employee_nip,
                nama: model.employee_name,
                unit_kerja: model.employee_current_work_unit_name,
                jabatan: model.employee_current_position_name,
                tmt_jabatan: model.employee_current_tmt_position,
                golongan: model.employee_current_rank_group_code,
                tgl_lahir: model.employee_date_of_birth,
                jenis_kelamin: model.gender_name
            }
        })
    }

     onChangeHukuman = (employee) => {
        var model = employee.model
        this.setState({
            hukumanSelected: employee.value,
        })
    }

   

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.listPegawaiChanel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            employeeItems: reformatEmployee(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

         this.createBloc.listHukumanChanel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            hukumanItems: reformatHukuman(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        

        this.createBloc.fetchPegawai()
        this.createBloc.fetchHukuman()
        
    }

 

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                           

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Tambah Data Hukuman</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >


                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Pilih Hukuman <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    value={this.state.hukumanItems.filter(option => 
                                                      option.value === this.state.hukumanSelected)}
                                                    onChange={
                                                      this.onChangeHukuman
                                                    }
                                                    required="required"
                                                    options={this.state.hukumanItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Hukuman"
                                                />
                                                <AvField
                                                    name="punishment_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="punishment_uuid"
                                                    value={this.state.hukumanSelected}
                                                />
                                            </Col>
                                        </Row>

                                      
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Pilih Pegawai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    value={this.state.employeeItems.filter(option => 
                                                      option.value === this.state.employeeSelected)}
                                                    onChange={
                                                      this.onChangeEmployee
                                                    }
                                                    required="required"
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pegawai"
                                                />
                                                <AvField
                                                    name="employee_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="employee_uuid"
                                                    value={this.state.employeeSelected}
                                                />
                                            </Col>
                                        </Row>
                                        
                                          <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            NIP 
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="nip"
                                                    placeholder="NIP..."
                                                    readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    id="nip"
                                                    value={this.state.dataForm.nip}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                           Nama Lengkap 
                                            </label>
                                            <Col md="5">
                                                  <AvField
                                                    name="nama_lengkap"
                                                    placeholder="Nama Lengkap..."
                                                    readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    id="nama_lengkap"
                                                    value={this.state.dataForm.nama}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                           Posisi 
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="posisi"
                                                    placeholder="Posisi..."
                                                    readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    id="posisi"
                                                    value={this.state.dataForm.jabatan}
                                                />
                                            </Col>
                                        </Row>

                                          <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                           Unit Kerja 
                                            </label>
                                            <Col md="5">
                                                 <AvField
                                                    name="keterangan"
                                                    placeholder="Unit Kerja ..."
                                                    readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    id="keterangan"
                                                     value={this.state.dataForm.unit_kerja}
                                                />
                                            </Col>
                                        </Row>

                                          <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                           Keterangan
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="keterangan"
                                                    placeholder="Keterangan..."
                                                    type="textarea"
                                                    className="form-control"
                                                    rows="8"
                                                    id="keterangan"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            No SK  <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="punishment_sk_number"
                                                    placeholder="No SK..."
                                                    type="text"
                                                    className="form-control"
                                                    id="punishment_sk_number"
                                                    required="required"
                                                    value={this.state.dataForm.punishment_sk_number}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="punishment_sk_date"
                                                    placeholder="Tanggal SK..."
                                                    type="date"
                                                    className="form-control"
                                                    id="punishment_sk_date"
                                                    required="required"
                                                    value={this.state.dataForm.punishment_sk_date}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal TMT SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="punishment_sk_tmt_date"
                                                    placeholder="Tanggal SK..."
                                                    type="date"
                                                    className="form-control"
                                                    id="punishment_sk_tmt_date"
                                                    required="required"
                                                    value={this.state.dataForm.punishment_sk_tmt_date}
                                                />
                                            </Col>
                                        </Row>


                                        
                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            File SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="document"
                                                />
                                            </Col>
                                        </Row>

                                     
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/hukuman.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/hukuman.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView